import { Menu, MenuButton, MenuItem, MenuList, Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PermissionValueEnum } from '@Types/administrator';
import { PermissionAction } from '@Types/permissions';

export default function PermissionMenu(props: {
  selectedStatus: PermissionValueEnum;
  setSelectedStatus: (status: PermissionValueEnum) => void;
}) {
  const PERMISSIONS = [
    PermissionValueEnum.ViewOnly,
    PermissionValueEnum.Editable,
    PermissionValueEnum.NoAccess,
  ];
  const permissionValueToName = {
    [PermissionValueEnum.ViewOnly]: PermissionAction.ViewOnly,
    [PermissionValueEnum.Editable]: PermissionAction.Editable,
    [PermissionValueEnum.NoAccess]: PermissionAction.NoAccess,
  };
  const { t } = useTranslation();

  const onClick = (e: any) => {
    props.setSelectedStatus(Number(e.target.value));
  };
  return (
    <Menu>
      <MenuButton variant="secondary" height="32px" width="328px">
        <Text>
          {t(
            'administration.rbac.permission.' +
              permissionValueToName[props.selectedStatus]
          )}
        </Text>
      </MenuButton>
      <MenuList width="328px" PopperProps={{ usePortal: true }}>
        {PERMISSIONS.map((status, i) => {
          return (
            <MenuItem onClick={onClick} key={i} cursor="pointer" value={status}>
              {t(
                'administration.rbac.permission.' +
                  permissionValueToName[status]
              )}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
}
